/* eslint-disable no-console */
import React from 'react';
import { useLocation } from 'react-router-dom';

import { styled } from '@mui/material/styles';
import { Box, SwipeableDrawer, useMediaQuery } from '@mui/material';

import useNavbarHeight from 'hooks/useNavbarHeight';

import SidebarMenu from './components/SidebarMenu';

const SidebarWrapper = styled(Box)(({ theme }) => ({
  width: '223px',
  height: '100vh',
  overflow: 'auto',
  position: 'fixed',
  paddingBottom: '16px !important',

  '&::-webkit-scrollbar': {
    display: 'none',
  },

  [theme.breakpoints.down('md')]: {
    width: '0px',
  },
}));

const Sidebar = ({ open, setOpen }) => {
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('md'));

  const navbarHeight = useNavbarHeight();

  const { pathname } = useLocation();

  const isWatchPagePath = pathname.includes('/student-learning/');

  return (
    (!isWatchPagePath || isMobile) && (
      // based on navbar-height-dashboard
      <SidebarWrapper pt={navbarHeight}>
        {!isMobile ? (
          <SidebarMenu setOpen={setOpen} />
        ) : (
          <SwipeableDrawer
            anchor="left"
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            PaperProps={{ sx: { width: '264px' } }}
          >
            <SidebarMenu setOpen={setOpen} />
          </SwipeableDrawer>
        )}
      </SidebarWrapper>
    )
  );
};

export default Sidebar;
